// extracted by mini-css-extract-plugin
export default {"PumpLend":"ElectricityBoxLend_PumpLend__YAErg","Error":"ElectricityBoxLend_Error__1FR1S"};